import { Extensions } from "@tiptap/core";
import Highlight from "@tiptap/extension-highlight";
import TextAlign from "@tiptap/extension-text-align";
import { Placeholder } from "@tiptap/extensions";
import StarterKit from "@tiptap/starter-kit";
import PollExtension from "./PollExtension";

interface Options {
  editable: boolean;
  placeholder?: string;
  // Polls are shown without voting, for previews
  previewPolls?: boolean;
}

// One schema for editing and showing, so saved html renders the same way
export const getRichTextExtensions = ({
  editable,
  placeholder,
  previewPolls = false,
}: Options): Extensions => [
  StarterKit.configure({
    heading: { levels: [2, 3] },
    code: false,
    codeBlock: false,
    link: {
      openOnClick: !editable,
      autolink: true,
      defaultProtocol: "https",
      HTMLAttributes: { target: "_blank", rel: "noopener noreferrer nofollow" },
    },
  }),
  TextAlign.configure({ types: ["heading", "paragraph"] }),
  Highlight,
  PollExtension.configure({ preview: previewPolls }),
  ...(editable && placeholder ? [Placeholder.configure({ placeholder })] : []),
];
